module.exports = __webpack_public_path__ + "img/capital_one.35ab7293.svg";